import React from 'react';

export default function PlusCircle({ style }) {
  return <i className="fas fa-plus-circle" style={{ ...style }}></i>;
}